import React, { forwardRef, useCallback, useState, FocusEvent } from "react";
import clsx from "clsx";
import styles from "./styles.module.css";

//React.ButtonHTMLAttributes<HTMLButtonElement>;
type InputProps = {
  // variant?: ButtonType;
  // intent?: Intent;
  // size?: Size;
  // children?: React.ReactNode;
  // className?: string;
  // IconBefore?: React.ReactNode;
  // IconAfter?: React.ReactNode;
  // loading?: boolean;
  hint?: string;
  RenderBefore?: React.ReactNode;
  RenderAfter?: React.ReactNode;
  error?: boolean;
  onFocus?: (e: FocusEvent<HTMLInputElement>) => void;
  onBlur?: (e: FocusEvent<HTMLInputElement>) => void;
  placeholder?: string;
  fullWidth?: boolean;
  readOnly?: boolean;
} & React.InputHTMLAttributes<HTMLInputElement>;

type State = {
  focus: boolean;
};
export const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      RenderBefore,
      RenderAfter,
      fullWidth = false,
      readOnly = false,
      error = false,
      ...props
    },
    ref,
  ) => {
    const { onFocus, onBlur, disabled, hint } = props;
    const [{ focus }, set] = useState<State>({ focus: false });

    const dispatch = (payload: Partial<State>) =>
      set((prev) => ({ ...prev, ...payload }));

    const focusHandle = useCallback(
      (e: FocusEvent<HTMLInputElement>) => {
        onFocus?.(e);

        if (!readOnly) {
          dispatch({ focus: true });
        }
      },
      [onFocus],
    );

    const blurHandle = useCallback(
      (e: FocusEvent<HTMLInputElement>) => {
        onBlur?.(e);
        dispatch({ focus: false });
      },
      [onBlur],
    );

    return (
      <div
        className={clsx(
          styles.base,
          focus && styles["_focused"],
          error && styles["_error"],
          hint && styles["_hint"],
          fullWidth && styles["_full"],
        )}
      >
        <label>
          {RenderBefore}
          <input
            autoComplete="off"
            {...props}
            readOnly={readOnly}
            ref={ref}
            disabled={disabled}
            onFocus={focusHandle}
            onBlur={blurHandle}
          />
          {RenderAfter}
        </label>
        <span className={styles.hint}>{hint}</span>
      </div>
    );
  },
);

export default Input;
